import { z } from 'zod';

export const CalendarViewTypeSchema = z.object({
  viewId: z.string(),
  type: z.literal('calendar'),
});

export const CalendarEventSelectionSchema = z.object({
  rowId: z.string(),
  selectionType: z.literal('event'),
});

export const CalendarCellSelectionSchema = z.object({
  columnId: z.string(),
  isEditing: z.boolean(),
  rowId: z.string(),
  selectionType: z.literal('cell'),
});

export const CalendarViewSelectionSchema = z.union([
  CalendarEventSelectionSchema,
  CalendarCellSelectionSchema,
]);

export const CalendarViewSelectionWithTypeSchema = z.union([
  z.intersection(CalendarViewTypeSchema, CalendarEventSelectionSchema),
  z.intersection(CalendarViewTypeSchema, CalendarCellSelectionSchema),
]);

export type CalendarEventSelection = z.TypeOf<
  typeof CalendarEventSelectionSchema
>;
export type CalendarCellSelection = z.TypeOf<
  typeof CalendarCellSelectionSchema
>;
export type CalendarViewSelection = z.TypeOf<
  typeof CalendarViewSelectionSchema
>;
export type CalendarViewSelectionWithType = z.TypeOf<
  typeof CalendarViewSelectionWithTypeSchema
>;
